import { Uuid } from "@/domains/global/identifiers";
import { UuidNamespace } from "@/modules/uuid/constants";
import { v5 as uuidv5 } from "uuid";

export const resolveSessionArtifactIdForCapturedAudio = ({
  sessionId,
  capturedAudioId,
}: {
  sessionId: Uuid;
  capturedAudioId: Uuid;
}): Uuid => {
  const upperSessionId = sessionId.toUpperCase();
  const upperCapturedAudioId = capturedAudioId.toUpperCase();
  const name = `${upperSessionId}::${upperCapturedAudioId}:`;

  return uuidv5(name, UuidNamespace.VoiceSessionArtifactNamespace);
};
